<script>
	export default {
		name: 'app',
	}
</script>

<template>
	<div>
		<transition>
			<router-view></router-view>
		</transition>
	</div>
</template>